module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14